export const CustomerFeedbackTypes = ['customerFeedback', 'crowdsourcing'];
